/* eslint-disable camelcase, react/jsx-pascal-case */
import MultiSelectBox_ListPreviewSortable from './multiSelectBox_ListPreviewSortable';

export default MultiSelectBox_ListPreviewSortable;
